// ------------------------------------------------------------------------------
// EmptyArtist
// author: mudas
// created: 2024/12/8
// ------------------------------------------------------------------------------

import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { Empty, Image } from '@fuxi/eevee-ui';

import NoArtistSVG from 'common/assets/image/no-artist.svg';
import DataNullPNG from 'common/assets/image/data-null.png';

export interface IProps {
  title?: ReactNode;
  content?: ReactNode;
  className?: string;

  // 显示图标（默认：'no-artist'）
  icon?: 'no-artist' | 'data-null';
}

const EmptyArtist: FC<PropsWithChildren<IProps>> = props => {
  const { title, content, icon = 'no-artist', className, children } = props;

  return (
    <div className={`flex-column-center gap-12 ${className}`}>
      {icon === 'no-artist' ? (
        <Image src={NoArtistSVG} preview={false} />
      ) : (
        <Empty description="" image={DataNullPNG} />
      )}

      <div className="flex-column-center gap-3 pb-10">
        {title && <div className="text-size-xl">{title}</div>}
        {content && <div className="text-color-tertiary">{content}</div>}
      </div>

      {children}
    </div>
  );
};

export default EmptyArtist;
